<template lang="pug">
  spreadsheet(:opts='group_opts')
</template>

<script>
// Generated by CoffeeScript 2.3.0

export default {
  data() {
    return {
      group_opts: {
        tableName: 'groups',
        displayName: '用户组',
        columns: [
          {
            label: '组名',
          },
          {
            label: '成员',
            type: 'disabled',
          },
        ],
        defaultItem: {
          permissions: {
            所有人: '读取',
          },
        },
        maxItem: 1000,
        showPagination: true,
        expandable: true,
        creatable: true,
        trackable: true,
        recycle: true,
      },
    }
  },
  created() {
    return this.checkRole()
  },
  methods: {
    checkRole() {
      const flag = app.user && app.user.角色 && app.user.角色.includes('管理员')
      if (!flag) router.push('/')
      // let ref
      // if (!(((ref = app.user) != null ? ref['角色'] : void 0) === '管理员')) {
      //   return router.push('/')
      // }
    },
  },
}
</script>
